// extracted by mini-css-extract-plugin
module.exports = {"formCard":"styles_formCard__anyK9","setPassword":"styles_setPassword__3_PBQ"};